import "./ui.css";

type SkeletonProps = {
  width?: string;
  height?: string;
  className?: string;
};

/**
 * Grijs blokje tijdens het laden. Krijgt geen eigen `aria-label`: de
 * omliggende laadstaat meldt één keer "wordt geladen", anders roept een
 * schermlezer dat per blokje opnieuw.
 */
export function Skeleton({ width = "100%", height = "1rem", className }: SkeletonProps) {
  return <span className={className ? `atl-skeleton ${className}` : "atl-skeleton"} style={{ width, height }} aria-hidden />;
}
